import _taggedTemplateLiteral from "/home/gatos/git/alfa-language-support-documentation/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import scStyled, { createGlobalStyle as createGlobalStyle$1, ThemeContext, ThemeProvider, css as css$1 } from 'styled-components';
export { ServerStyleSheet, StyleSheetManager, ThemeConsumer, ThemeContext, ThemeProvider, isStyledComponent, keyframes, withTheme } from 'styled-components';
import { createColorStyles, createColorModeProvider, createUseGetter, useThemeScreens, useThemeBreakpoint, useThemeUp, useThemeDown, createTransform } from '@xstyled/core';
export { getColorModeInitScriptElement, getColorModeInitScriptTag, useColorMode, useViewportWidth } from '@xstyled/core';
import { useContext } from 'react';
import { th, getPreflightStyles, system as system$1 } from '@xstyled/system';
export * from '@xstyled/system';
import { flattenStrings, string } from '@xstyled/util';
var ColorModeStyle = createGlobalStyle$1(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return createColorStyles(p.theme, {
    targetSelector: p.targetSelector
  });
});
var ColorModeProvider = createColorModeProvider({
  ThemeContext: ThemeContext,
  ThemeProvider: ThemeProvider,
  ColorModeStyle: ColorModeStyle
});

var useTheme = function useTheme() {
  return useContext(ThemeContext);
};

var useTh = createUseGetter(th, useTheme);
var useAngle = createUseGetter(th.angle, useTheme);
var useAnimation = createUseGetter(th.animation, useTheme);
var useBorder = createUseGetter(th.border, useTheme);
var useBorderColor = createUseGetter(th.borderColor, useTheme);
var useBorderStyle = createUseGetter(th.borderStyle, useTheme);
var useBorderWidth = createUseGetter(th.borderWidth, useTheme);
var useColor = createUseGetter(th.color, useTheme);
var useDuration = createUseGetter(th.duration, useTheme);
var useFont = createUseGetter(th.font, useTheme);
var useFontSize = createUseGetter(th.fontSize, useTheme);
var useFontWeight = createUseGetter(th.fontWeight, useTheme);
var useInset = createUseGetter(th.inset, useTheme);
var useLetterSpacing = createUseGetter(th.letterSpacing, useTheme);
var useLineHeight = createUseGetter(th.lineHeight, useTheme);
var usePercent = createUseGetter(th.percent, useTheme);
var usePx = createUseGetter(th.px, useTheme);
var useRadius = createUseGetter(th.radius, useTheme);
var useRingWidth = createUseGetter(th.ringWidth, useTheme);
var useShadow = createUseGetter(th.shadow, useTheme);
var useSize = createUseGetter(th.size, useTheme);
var useSpace = createUseGetter(th.space, useTheme);
var useTimingFunction = createUseGetter(th.timingFunction, useTheme);
var useTransform = createUseGetter(th.transform, useTheme);
var useTransition = createUseGetter(th.transition, useTheme);
var useTransitionProperty = createUseGetter(th.transitionProperty, useTheme);
var useZIndex = createUseGetter(th.zIndex, useTheme);

var useScreens = function useScreens() {
  return useThemeScreens(useTheme());
};

var useBreakpoint = function useBreakpoint() {
  return useThemeBreakpoint(useTheme());
};

var useUp = function useUp(key) {
  return useThemeUp(useTheme(), key);
};

var useDown = function useDown(key) {
  return useThemeDown(useTheme(), key);
};

var Preflight = createGlobalStyle$1(function (_ref) {
  var theme = _ref.theme;
  return getPreflightStyles(theme);
});

var createCssFunction = function createCssFunction(generator) {
  var transform = createTransform(generator);
  return function () {
    var scCssArgs = css$1.apply(void 0, arguments);
    var flattenedArgs = flattenStrings(scCssArgs);
    return flattenedArgs.map(transform);
  };
};

var getCreateStyle = function getCreateStyle(baseCreateStyle, css, generator) {
  var createStyle = function createStyle() {
    return baseCreateStyle(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", "", ""])), css.apply(void 0, arguments), generator);
  };

  createStyle.attrs = function (attrs) {
    return getCreateStyle(baseCreateStyle.attrs(attrs), css, generator);
  };

  createStyle.withConfig = function (config) {
    return getCreateStyle(baseCreateStyle.withConfig(config), css, generator);
  };

  return createStyle;
};

var createShouldForwardProp = function createShouldForwardProp(generator) {
  var propSet = new Set(generator.meta.props);
  return function (prop, defaultValidatorFn, elementToBeCreated) {
    if (string(prop) && propSet.has(prop)) {
      return false;
    }

    if (typeof elementToBeCreated === "string") {
      return defaultValidatorFn(prop);
    }

    return true;
  };
};

var createBaseStyled = function createBaseStyled(css, generator) {
  var config = generator ? {
    shouldForwardProp: createShouldForwardProp(generator)
  } : {};
  return function (component) {
    var baseStyled = scStyled(component);
    return getCreateStyle(config ? baseStyled.withConfig(config) : baseStyled, css, generator);
  };
};

var createStyled = function createStyled(generator) {
  var css = createCssFunction(generator);
  var styled = createBaseStyled(css);
  var xstyled = createBaseStyled(css, generator);
  styled.box = xstyled("div");
  Object.keys(scStyled).forEach(function (key) {
    styled[key] = styled(key);
    styled["".concat(key, "Box")] = xstyled(key);
  });
  return styled;
};

var createX = function createX(generator) {
  var xstyled = createBaseStyled(createCssFunction(generator), generator);
  var x = {};
  Object.keys(scStyled).forEach(function (tag) {
    x[tag] = xstyled(tag)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
  });
  return x;
};

var createCreateGlobalStyle = function createCreateGlobalStyle(generator) {
  var css = createCssFunction(generator);
  return function () {
    return createGlobalStyle$1([css.apply(void 0, arguments)]);
  };
};

var createCss = function createCss(generator) {
  return {
    css: createCssFunction(generator),
    x: createX(generator),
    styled: createStyled(generator),
    createGlobalStyle: createCreateGlobalStyle(generator)
  };
};

var _createCss = createCss(system$1),
    css = _createCss.css,
    styled = _createCss.styled,
    x = _createCss.x,
    createGlobalStyle = _createCss.createGlobalStyle;

export default styled;
export { ColorModeProvider, Preflight, createCss, createGlobalStyle, css, useAngle, useAnimation, useBorder, useBorderColor, useBorderStyle, useBorderWidth, useBreakpoint, useColor, useDown, useDuration, useFont, useFontSize, useFontWeight, useInset, useLetterSpacing, useLineHeight, usePercent, usePx, useRadius, useRingWidth, useScreens, useShadow, useSize, useSpace, useTh, useTheme, useTimingFunction, useTransform, useTransition, useTransitionProperty, useUp, useZIndex, x };